(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1237,33205],{

/***/ 30877:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.e = function BsThreeDots (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 16 16","fill":"currentColor"},"child":[{"tag":"path","attr":{"fillRule":"evenodd","d":"M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","clipRule":"evenodd"}}]})(props);
};


/***/ }),

/***/ 70454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var BackButton = function(param) {
    var isAppWebView = param.isAppWebView, _color = param.color, color = _color === void 0 ? "black" : _color, _top = param.top, top = _top === void 0 ? "top-4" : _top, _left = param.left, left = _left === void 0 ? "left-2" : _left;
    return null;
// const router = useRouter();
// if (!isAppWebView) {
//   return null;
// }
// return (
//   <button
//     onClick={() => router.back()}
//     className={`absolute ${top} ${left} sm:left-0 flex p-2 rounded-full backdrop-blur-sm transition-all text-brand-black group z-20`}
//   >
//     <Image
//       src={
//         color == "white"
//           ? "/icons/left-arrow-white.svg"
//           : "/icons/left-arrow.svg"
//       }
//       alt="Geri"
//       width={32}
//       height={32}
//     />
//   </button>
// );
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 74840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80103);



var CustomerItem = function(param) {
    var title = param.title, subTitle = param.subTitle, onchange = param.onchange, defaultValue = param.defaultValue, max = param.max, min = param.min;
    var countUp = function countUp() {
        if (max || max == 0) {
            if (count < max) setCount(count + 1);
        } else {
            setCount(count + 1);
        }
    };
    var countDown = function countDown() {
        if (min) {
            if (count > min) setCount(count - 1);
        } else {
            if (count > 0) setCount(count - 1);
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultValue ? parseInt(defaultValue) : 0), count = ref[0], setCount = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), isFirst = ref1[0], setIsFirst = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isFirst == 1) onchange(count);
        setIsFirst(1);
    }, [
        count
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex justify-between items-center mb-2.5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-bold text-sm",
                        children: title
                    }),
                    subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-medium opacity-30 text-xs",
                        children: subTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "w-8 h-8 border border-brand-gray-8 flex items-center justify-center",
                        onClick: countDown,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            name: "Minus"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "w-10 h-8 text-center leading-7 font-bold text-xl text-brand-black-2",
                        children: count
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "w-8 h-8 border border-brand-gray-8 flex items-center justify-center",
                        onClick: countUp,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            name: "Plus"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomerItem);


/***/ }),

/***/ 79530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index_ShortTerms; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Index/ShortTerms.module.css
var ShortTerms_module = __webpack_require__(63964);
var ShortTerms_module_default = /*#__PURE__*/__webpack_require__.n(ShortTerms_module);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/bs/BsThreeDots.js
var BsThreeDots = __webpack_require__(30877);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/TermItem.module.css
var TermItem_module = __webpack_require__(79639);
var TermItem_module_default = /*#__PURE__*/__webpack_require__.n(TermItem_module);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/TermItem.js





var TermItem = function(param) {
    var data = param.data;
    var nights = (0,TranslationContext/* useTranslation */.m)().nights;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-kisasureli-bg rounded-md py-5 px-4 flex flex-col transform transition-shadow hover:shadow-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "bg-white rounded-sm text-black text-15 text-center p-3 font-medium",
                    children: data.ay
                }),
                data.deger.map(function(day, dayindex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: day.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            title: day.title,
                            className: "mt-3 flex justify-between text-13 items-center ml-1 group " + (TermItem_module_default()).ShortTermDay,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-brand-black-2 font-bold",
                                    children: [
                                        day.gece,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-normal lg:ml-3",
                                            children: nights
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-white bg-kisasureli-count-bg bg-transparent transform transition-all duration-200 group-hover:bg-none group-hover:text-brand-orange-2 rounded-2xl w-14 text-13 text-center py-1 group-hover:bg-white",
                                    children: day.adet
                                })
                            ]
                        })
                    }, dayindex);
                })
            ]
        })
    });
};
/* harmony default export */ var components_TermItem = (TermItem);

// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
;// CONCATENATED MODULE: ./components/Index/ShortTerms.js









var ShortTerms = function(param) {
    var hideTitle = param.hideTitle;
    var ref = (0,TranslationContext/* useTranslation */.m)(), shortTermsTitle = ref.shortTermsTitle, all = ref.all;
    var ref1 = (0,react.useState)([]), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react.useState)(false), page = ref2[0], setPage = ref2[1];
    (0,react.useEffect)(function() {
        (0,api/* HomeShortTerms */.Hz)().then(function(result) {
            setData(result.data.data);
            setPage(result.data.page);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (hideTitle ? (ShortTerms_module_default()).HideTitle : "mt-12 lg:mt-36 pb-24") + " relative " + (ShortTerms_module_default()).ShortTermsBg,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col lg:items-center gap-y-6 lg:gap-y-0",
            children: [
                !hideTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "font-bold text-xl lg:text-3xl text-brand-black lg:text-orange lg:leading-69 lg:mb-10",
                            children: shortTermsTitle
                        }),
                        page && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: page.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                title: page.title,
                                className: "text-brand-black font-bold text-13 lg:hidden self-end",
                                children: [
                                    all,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BsThreeDots/* BsThreeDots */.e, {
                                        size: "36",
                                        className: "inline-block text-brand-blue"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full overflow-x-auto lg:flex-wrap pb-5 lg:pb-0",
                    children: data.length == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-none px-2 lg:py-2 w-44 sm:w-5/12 lg:w-4/12 xl:w-1/6 first:pl-0 last:pr-0 h-[300px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    className: "w-full h-full"
                                })
                            })
                        ]
                    }) : data.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TermItem, {
                            data: item
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Index_ShortTerms = (ShortTerms);


/***/ }),

/***/ 14082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63805);
/* harmony import */ var is_mobile__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(is_mobile__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_getMobilePlatform__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62647);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73040);





var KiralaGelBanner = function(param) {
    var src = param.src, listingPage = param.listingPage, roundedClass = param.roundedClass, deviceType = param.deviceType;
    var learnMore = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .m)().learnMore;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("https://www.kiralagel.com"), href = ref[0], setHref = ref[1];
    var isWide = src === null || src === void 0 ? void 0 : src.includes("1350x210");
    var aspectClass = isWide ? "aspect-[1350/210]" : "aspect-[575/260]";
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isPhone = is_mobile__WEBPACK_IMPORTED_MODULE_1___default()();
        var platform = (0,_utils_getMobilePlatform__WEBPACK_IMPORTED_MODULE_4__/* .getMobilePlatform */ .W)();
        var mobileHref = platform === "ios" || deviceType === "ios" ? "https://apps.apple.com/us/app/kiralagel/id6762357016" : "https://play.google.com/store/apps/details?id=com.boceksoftware.kiralagelapp";
        setHref(isPhone || deviceType ? mobileHref : "https://www.kiralagel.com");
    }, [
        deviceType
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "block w-full ".concat(aspectClass, " bg-contain bg-no-repeat bg-center relative ").concat(roundedClass, " ").concat(listingPage ? "" : " my-6 xl:my-10"),
        style: {
            backgroundImage: "url(".concat(src, ")")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute bottom-4 left-1/2 -translate-x-1/2 text-[rgba(52,55,56,1)] bg-white/60 backdrop-blur- z-10 px-4 sm:px-8 py-2 sm:py-3 rounded-full font-bold shadow-xl transform transition-all duration-300 hover:bg-white hover:scale-105 active:scale-95 whitespace-nowrap text-sm lg:text-base tracking-wide",
            children: learnMore
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KiralaGelBanner);


/***/ }),

/***/ 1550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84849);



var SkeletonView = function(param) {
    var isPhone = param.isPhone, _lengthMobile = param.lengthMobile, lengthMobile = _lengthMobile === void 0 ? 2 : _lengthMobile, _length = param.length, length = _length === void 0 ? 3 : _length, _flex = param.flex, flex = _flex === void 0 ? true : _flex, _width = param.width, width = _width === void 0 ? "ml:w-[350px]" : _width, _padding = param.padding, padding = _padding === void 0 ? "px-4" : _padding;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setMounted(true);
    }, []);
    if (isPhone && mounted) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(flex ? "gap-x-2 snap-x" : "flex-col gap-y-2 snap-y", " flex overflow-x-hidden snap-mandatory ").concat(padding),
            children: Array.from({
                length: lengthMobile
            }).map(function(_, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-11/12 ".concat(width, " shrink-0 grow-0 basis-auto snap-start bg-white shadow-sm border border-gray-100 rounded-2xl overflow-hidden"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: 208,
                            containerClassName: "flex",
                            borderRadius: 0
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "p-4 border-b border-gray-100 flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col gap-1 w-2/3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 18,
                                            width: "80%"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 12,
                                            width: "50%"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col items-end gap-1 w-1/3 text-right",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 18,
                                            width: "90%"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 10,
                                            width: "60%"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "p-3 flex justify-between bg-gray-50/50",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            circle: true,
                                            height: 14,
                                            width: 14
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 10,
                                            width: 20
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            circle: true,
                                            height: 14,
                                            width: 14
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 10,
                                            width: 20
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            circle: true,
                                            height: 14,
                                            width: 14
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            height: 10,
                                            width: 20
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, i);
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6",
        children: Array.from({
            length: length
        }).map(function(_, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(i === 3 ? "hidden xl:flex" : i === 2 ? "hidden md:flex" : "flex", " flex-col bg-white shadow-sm border border-gray-100"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        height: 280,
                        borderRadius: 0,
                        containerClassName: "flex"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "p-6 border-b border-gray-100 flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-2 w-1/2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 24,
                                        width: "80%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 16,
                                        width: "60%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-end gap-1 w-1/2 text-right",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 24,
                                        width: "70%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 14,
                                        width: "50%"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "p-5 flex justify-between bg-gray-50/30",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        circle: true,
                                        height: 20,
                                        width: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 14,
                                        width: 30
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        circle: true,
                                        height: 20,
                                        width: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 14,
                                        width: 30
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        circle: true,
                                        height: 20,
                                        width: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        height: 14,
                                        width: 30
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, i);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonView);


/***/ }),

/***/ 71593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Blur; }
/* harmony export */ });
var Remote = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    if (width > 1920) width = 1920;
    return "".concat("https://cdn.villavillam.com.tr", "/uploads/").concat(width, "/").concat(src);
};
var Blur = function(src) {
    return "".concat("https://cdn.villavillam.com.tr", "/uploads/30/").concat(src);
};
/* harmony default export */ __webpack_exports__["Z"] = (Remote);


/***/ }),

/***/ 33205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var AnimatedDiv = function(param) {
    var children = param.children, animate = param.animate, onClose = param.onClose;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), dragY = ref[0], setDragY = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isDragging = ref1[0], setIsDragging = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), mounted = ref2[0], setMounted = ref2[1];
    var startY = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // Trigger entry animation
        var timer = setTimeout(function() {
            return setMounted(true);
        }, 10);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    var handleTouchStart = function(e) {
        startY.current = e.touches[0].clientY;
        setIsDragging(true);
    };
    var handleTouchMove = function(e) {
        var currentY = e.touches[0].clientY;
        var diff = currentY - startY.current;
        // Only allow dragging downwards
        if (diff > 0) {
            setDragY(diff);
        }
    };
    var handleTouchEnd = function() {
        setIsDragging(false);
        // If dragged down more than 120px, close it
        if (dragY > 120) {
            setDragY(500); // Visual slide down
            setTimeout(function() {
                if (onClose) onClose();
            }, 200);
        } else {
            setDragY(0);
        }
    };
    // Base transition style
    var transition = isDragging ? "none" : "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "fixed z-[53] left-0 w-screen bg-white pb-8 border-t border-gray-100 bottom-0 sm:bottom-16 rounded-t-[2.5rem] shadow-[0_-10px_40px_rgba(0,0,0,0.1)]",
        style: {
            transform: "translateY(".concat(!mounted ? "100%" : "".concat(dragY, "px"), ")"),
            transition: transition
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full pt-4 pb-6 flex justify-center cursor-ns-resize touch-none select-none",
                onTouchStart: handleTouchStart,
                onTouchMove: handleTouchMove,
                onTouchEnd: handleTouchEnd,
                onClick: function() {
                    // Optional: clicking the handle also closes it
                    setDragY(500);
                    setTimeout(function() {
                        return onClose && onClose();
                    }, 200);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-1.5 w-14 bg-gray-200 rounded-full shadow-inner"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overflow-y-auto max-h-[70vh] px-4",
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AnimatedDiv);


/***/ }),

/***/ 1237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pages_ProductCategory; },
  "getCookie": function() { return /* binding */ getCookie; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/VillaItem.js
var VillaItem = __webpack_require__(70235);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./themes/themes.js
var themes = __webpack_require__(89507);
// EXTERNAL MODULE: ./components/LoaderRemote.js
var LoaderRemote = __webpack_require__(71593);
// EXTERNAL MODULE: ./components/ProductCategory/Banner.module.css
var Banner_module = __webpack_require__(7461);
var Banner_module_default = /*#__PURE__*/__webpack_require__.n(Banner_module);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
// EXTERNAL MODULE: ./components/BackButton.js
var BackButton = __webpack_require__(70454);
;// CONCATENATED MODULE: ./components/ProductCategory/Banner.js








var Banner = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView;
    var forYou = (0,TranslationContext/* useTranslation */.m)().forYou;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "overflow-hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    ssr.result.kapak && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        loader: LoaderRemote/* default */.Z,
                        src: ssr.result.kapak + "?l=0",
                        layout: "fill",
                        objectFit: "contain",
                        objectPosition: "right",
                        alt: ssr.result.title,
                        priority: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center container py-8 sm:py-0 relative content-center justify-center flex flex-col sm:min-h-56 bg-gradient-to-b from-transparent ".concat(themes/* default.toBrand7 */.Z.toBrand7, " to-brand-gray-7 pt-12 sm:pt-16"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                                isAppWebView: isAppWebView,
                                top: "top-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-2xl sm:text-[42px] sm:leading-[55px] font-bold",
                                children: [
                                    ssr.RoutingTypeId == "ProductCategory" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-brand-blue",
                                        children: [
                                            forYou,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "inline-block " + (Banner_module_default()).TextWhiteShadow,
                                        children: ssr.result.baslik
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                className: "text-xs sm:text-15 text-brand-black opacity-50 leading-5 mt-4" + (Banner_module_default()).TextWhiteShadow,
                                children: ssr.result.kisa_icerik
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ProductCategory_Banner = (Banner);

// EXTERNAL MODULE: ./components/Menubar/AnimatedDiv.js
var AnimatedDiv = __webpack_require__(33205);
// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
// EXTERNAL MODULE: ./components/Index/SliderFormDatepicker.js
var SliderFormDatepicker = __webpack_require__(28886);
// EXTERNAL MODULE: ./components/Index/SliderFormSelect.js
var SliderFormSelect = __webpack_require__(3413);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-detect-click-outside/dist/index.js
var dist = __webpack_require__(49689);
// EXTERNAL MODULE: ./components/Detail/CustomerItem.js
var CustomerItem = __webpack_require__(74840);
;// CONCATENATED MODULE: ./components/ProductCategory/FormCustomer.js







var FormCustomer = function(param) {
    var setParam = param.setParam, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var ref = (0,TranslationContext/* useTranslation */.m)(), customer = ref.customer, adult = ref.adult, child = ref.child, childAge = ref.childAge, infant = ref.infant, infantAge = ref.infantAge;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(router.query.yetiskin || 1), yetiskin = ref1[0], setYetiskin = ref1[1];
    var ref2 = (0,react.useState)(router.query.cocuk || 0), cocuk = ref2[0], setCocuk = ref2[1];
    var ref3 = (0,react.useState)(router.query.bebek || 0), bebek = ref3[0], setBebek = ref3[1];
    var ref4 = (0,react.useState)(false), isOpen = ref4[0], setIsOpen = ref4[1];
    var CloseToggle = function() {
        setIsOpen(0);
    };
    var ref5 = (0,dist/* useDetectClickOutside */.I)({
        onTriggered: CloseToggle
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white flex flex-col relative",
        ref: ref5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center lg:py-5 lg:pl-8 lg:pr-7 cursor-pointer",
                onClick: function() {
                    setIsOpen(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-between flex-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold text-brand-gray-2 text-13 w-full",
                                    children: customer
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-bold text-xl mr-8",
                                    children: [
                                        yetiskin,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xs -top-0.5 relative inline-block ml-1.5",
                                            children: adult
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-bold text-xl",
                                    children: [
                                        cocuk,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xs -top-0.5 relative inline-block ml-1.5",
                                            children: child
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                            name: "ArrowDown"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex z-10 bg-white flex-col py-5 lg:px-7 top-full absolute w-full origin-top transition-transform transform-gpu ".concat(isOpen ? "scale-y-100 " : "scale-y-0 "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem/* default */.Z, {
                        title: adult,
                        onchange: function(e) {
                            setYetiskin(e);
                            var a = {};
                            a.yetiskin = e;
                            setParam(a);
                        },
                        defaultValue: yetiskin,
                        min: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem/* default */.Z, {
                        title: child,
                        subTitle: childAge,
                        onchange: function(e) {
                            setCocuk(e);
                            var a = {};
                            a.cocuk = e;
                            setParam(a);
                        },
                        max: 2,
                        defaultValue: cocuk
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerItem/* default */.Z, {
                        title: infant,
                        subTitle: infantAge,
                        onchange: function(e) {
                            setBebek(e);
                            var a = {};
                            a.bebek = e;
                            setParam(a);
                        },
                        max: 2,
                        defaultValue: bebek
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ProductCategory_FormCustomer = (FormCustomer);

;// CONCATENATED MODULE: ./components/ProductCategory/TopSearchBarContent.js







var TopSearchBarContent = function(param) {
    var setParam = param.setParam, isMobile = param.isMobile, onClick = param.onClick, RoutingTypeId = param.RoutingTypeId, PageId = param.PageId;
    var ref = (0,TranslationContext/* useTranslation */.m)(), SearchResultTitle = ref.SearchResultTitle, destination = ref.destination, villaOptions = ref.villaOptions, checkInOutDate = ref.checkInOutDate, searchUpper = ref.searchUpper;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg:bg-list-searchBar-bg relative lg:py-7",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container flex flex-col lg:flex-row ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white pb-16 pt-6 lg:px-9 lg:py-0 flex-1 flex lg:items-center flex-col lg:flex-row min-w-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden xl:flex xl:mr-20 2xl:mr-40 items-center lg:items-start ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "listIcons",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                                        name: "search"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold ml-6 lg:w-32 leading-4 text-brand-black",
                                    children: SearchResultTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-1 min-w-0 flex-col lg:flex-row ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderFormSelect/* default */.Z, {
                                    label: destination,
                                    className: "w-full lg:w-1/4 relative field-border transition-all py-2.5",
                                    data: "/GetSearchBoxData?table=destinations",
                                    name: "bolge",
                                    setParam: setParam,
                                    selected: RoutingTypeId == "ProductDestination" ? PageId : null
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderFormSelect/* default */.Z, {
                                    label: villaOptions,
                                    className: "w-full lg:w-1/4 relative field-border transition-all py-2.5",
                                    data: "/GetSearchBoxData?table=tip",
                                    name: "tip",
                                    setParam: setParam,
                                    selected: RoutingTypeId == "ProductCategory" ? PageId : null
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderFormDatepicker/* default */.Z, {
                                    label: checkInOutDate,
                                    setParam: setParam,
                                    className: "w-full lg:w-1/4 relative field-border transition-all py-2.5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_FormCustomer, {
                                    isMobile: isMobile,
                                    setParam: setParam
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: isMobile ? "button" : "submit",
                    onClick: function() {
                        isMobile && onClick ? onClick() : "";
                    },
                    className: "bg-primary py-4 lg:py-0 text-white lg:w-32 font-bold mt-auto lg:mt-0",
                    children: searchUpper
                })
            ]
        })
    });
};
/* harmony default export */ var ProductCategory_TopSearchBarContent = (TopSearchBarContent);

// EXTERNAL MODULE: ./components/windowDimension.js
var windowDimension = __webpack_require__(16625);
// EXTERNAL MODULE: ./context/context.js
var context = __webpack_require__(94268);
;// CONCATENATED MODULE: ./components/ProductCategory/TopSearchBar.js






var TopSearchBar = function(param) {
    var setParam = param.setParam, RoutingTypeId = param.RoutingTypeId, PageId = param.PageId;
    var ref = (0,react.useContext)(context/* StoreContext */.x), backdrop = ref.backdrop, setBackdrop = ref.setBackdrop, mobileBar = ref.mobileBar, setMobileBar = ref.setMobileBar;
    var width = (0,windowDimension/* default */.Z)().width;
    (0,react.useEffect)(function() {
        setBackdrop(mobileBar);
    }, [
        mobileBar
    ]);
    (0,react.useEffect)(function() {
        if (backdrop == false) CloseAll();
    }, [
        backdrop
    ]);
    var CloseAll = function() {
        setMobileBar(false);
    };
    if (width >= 1024) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_TopSearchBarContent, {
            setParam: setParam,
            isMobile: false,
            RoutingTypeId: RoutingTypeId,
            PageId: PageId
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: mobileBar == "ProductSearch" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedDiv["default"], {
            onClose: CloseAll,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_TopSearchBarContent, {
                setParam: setParam,
                isMobile: true,
                RoutingTypeId: RoutingTypeId,
                onClick: CloseAll,
                PageId: PageId
            })
        })
    });
};
/* harmony default export */ var ProductCategory_TopSearchBar = (TopSearchBar);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components/ProductCategory/FormField.js





var FormField = function(param) {
    var children = param.children, className = param.className, DropWrapperContent = param.DropWrapperContent, dropProps = param.dropProps;
    var ref = (0,react.useState)(0), isOpen = ref[0], setIsOpen = ref[1];
    var toggle = function() {
        setIsOpen(!isOpen);
    };
    var CloseToggle = function() {
        setIsOpen(0);
    };
    var ref1 = (0,dist/* useDetectClickOutside */.I)({
        onTriggered: CloseToggle
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref1,
        onClick: function() {
            setIsOpen(1);
        },
        className: "border-b w-full ml:w-auto text-center cursor-pointer relative lg:border-b-0 lg:border-r border-brand-gray-7 px-5 py-2 ml:py-5 min-w-[175px] lg:first:pl-0 group " + (className ? className : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center sm:justify-between items-center ",
                children: children
            }),
            DropWrapperContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute border-t-2 z-30 top-full py-4 px-6 bg-white w-full right-0 shadow-xl transition-transform transform-gpu origin-top min-w-[300px] " + (isOpen ? "scale-y-100" : "scale-y-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropWrapperContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dropProps), {
                    close: CloseToggle
                }))
            })
        ]
    });
};
/* harmony default export */ var ProductCategory_FormField = (FormField);

;// CONCATENATED MODULE: ./components/ProductCategory/FormOrderOptions.js


var FormOrderOptions = function(param) {
    var orderOptions = param.orderOptions, setOrder = param.setOrder, order = param.order, setParam = param.setParam, close = param.close;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col",
            children: orderOptions && orderOptions.map(function(item, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex py-1 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "form_order_" + item.value,
                            name: "push-notifications",
                            type: "radio",
                            onChange: function() {
                                setOrder(item.value);
                                var a = {};
                                a["order_by"] = item.value;
                                setParam(a);
                                close();
                            },
                            checked: order == item.value,
                            className: "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                            htmlFor: "form_order_" + item.value,
                            className: "ml-3 block text-sm font-medium text-gray-700",
                            children: item.label
                        })
                    ]
                }, key);
            })
        })
    });
};
/* harmony default export */ var ProductCategory_FormOrderOptions = (FormOrderOptions);

;// CONCATENATED MODULE: ./components/ProductCategory/FormOrder.js







var FormOrder = function(param) {
    var setParam = param.setParam;
    var ref = (0,TranslationContext/* useTranslation */.m)(), SearchResultFilterOrderPlaceHolder = ref.SearchResultFilterOrderPlaceHolder, orderOptions = ref.orderOptions;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(router.query.order_by ? router.query.order_by : 0), order = ref1[0], setOrder = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCategory_FormField, {
        DropWrapperContent: ProductCategory_FormOrderOptions,
        dropProps: {
            setParam: setParam,
            setOrder: setOrder,
            order: order,
            orderOptions: orderOptions
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "font-semibold text-brand-gray-9 mr-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "hidden sm:inline-block",
                        children: [
                            SearchResultFilterOrderPlaceHolder,
                            " :",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-black text-sm",
                        children: orderOptions.find(function(x) {
                            return x.value == order;
                        }).label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                name: "ArrowDown",
                className: "group-hover:text-brand-color-primary"
            })
        ]
    });
};
/* harmony default export */ var ProductCategory_FormOrder = (FormOrder);

;// CONCATENATED MODULE: ./components/ProductCategory/FilterSummary.js

// import React from "react";

// import { useTranslation } from "../../context/TranslationContext";
// import CalendarRuleCheckbox from "./CalendarRuleCheckbox";
var FilterSummary = function(param) {
    var totalRecord = param.totalRecord, setParam = param.setParam;
    // const { SearchResultFilterSummeryText } = useTranslation();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between flex-col pt-4 ml:pt-0 ml:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-13 whitespace-nowrap font-poppins font-semibold"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_FormOrder, {
                    setParam: setParam
                })
            ]
        })
    });
};
/* harmony default export */ var ProductCategory_FilterSummary = (FilterSummary);

// EXTERNAL MODULE: ./components/api.js
var api = __webpack_require__(9012);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
;// CONCATENATED MODULE: ./components/ProductCategory/Content.js



var Content = function(param) {
    var content = param.content;
    var ref = (0,react.useState)(0), readMore = ref[0], setReadMore = ref[1];
    var Toggle = function() {
        setReadMore(!readMore);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white p-4 mt-5 rounded-lg shadow-lg text-gray-500 leading-6 ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " transform-gpu  transition-all",
            dangerouslySetInnerHTML: {
                __html: content
            }
        })
    });
};
/* harmony default export */ var ProductCategory_Content = (Content);

// EXTERNAL MODULE: ./components/ProductCategory/Pagination.js + 1 modules
var Pagination = __webpack_require__(73870);
// EXTERNAL MODULE: ./components/Index/ShortTerms.js + 1 modules
var ShortTerms = __webpack_require__(79530);
// EXTERNAL MODULE: ./scripts/criteo.js
var criteo = __webpack_require__(77793);
// EXTERNAL MODULE: ./components/KiralaGelBanner.js
var KiralaGelBanner = __webpack_require__(14082);
// EXTERNAL MODULE: ./components/ListVilla/SkeletonView.js
var SkeletonView = __webpack_require__(1550);
// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
;// CONCATENATED MODULE: ./components/Pages/ProductCategory.js




















function getCookie(name) {
    if (typeof document === "undefined") return null;
    var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
}
var ProductCategory = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    var searchResultSlug = (0,TranslationContext/* useTranslation */.m)().searchResultSlug;
    var router = (0,next_router.useRouter)();
    var width = (0,windowDimension/* default */.Z)().width;
    var isPhone = is_mobile_default()();
    var page = ssr.result;
    var currentRoutingTypeId = ssr.RoutingTypeId;
    var ref = (0,react.useState)(0), currentPage = ref[0], setcurrentPage = ref[1];
    var ref1 = (0,react.useState)(0), totalPage = ref1[0], setTotalPage = ref1[1];
    var ref2 = (0,react.useState)(0), totalRecord = ref2[0], setTotalRecord = ref2[1];
    var ref3 = (0,react.useState)(false), data = ref3[0], setData = ref3[1];
    var ref4 = (0,react.useState)(true), isLoading = ref4[0], setIsloading = ref4[1];
    var ref5 = (0,react.useState)(), error = ref5[0], setError = ref5[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        setIsloading(true);
        setcurrentPage(parseInt(router.query.s ? router.query.s : 1));
        (0,api/* FilterApi */.Qt)({
            page: router.query.s ? router.query.s : 1,
            CurrentRoutingTypeId: currentRoutingTypeId,
            EntityId: ssr.EntityId,
            searchdate1: router.query.start || "",
            searchdate2: router.query.end || "",
            bolge: router.query.bolge || "",
            tip: router.query.tip || "",
            yetiskin: router.query.yetiskin || 1,
            cocuk: router.query.cocuk || 0,
            order_by: router.query.order_by || 0,
            ay: router.query.ay || 0,
            gece: router.query.gece || 0,
            min: router.query.min || "",
            max: router.query.max || "",
            showall: ssr.result.ShowTopSearchBar == "0" ? 1 : 0,
            ids: router.query.ids || "",
            search: router.query.search || "",
            customList: (page === null || page === void 0 ? void 0 : (ref = page.CustomList) === null || ref === void 0 ? void 0 : ref.PageId) || 0,
            disableCalendarRules: (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.disableCalendarRules) || 0,
            userLink: getCookie("user-link") || 0
        }).then(function(response) {
            if (response.data.error) {
                setError(response.data.error);
                setData(false);
            } else {
                setData(response.data.result);
                setError(false);
            }
            setTotalRecord(response.data.TotalRecord);
            setTotalPage(response.data.TotalPage);
        }).catch(function(error) {
            react_toastify_esm/* toast.error */.Am.error(error.message);
            setError(error.message);
        }).finally(function() {
            setIsloading(false);
        });
    }, [
        router.query
    ]);
    var setParam = function(obj) {
        var query = router.query;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                query[key] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (currentRoutingTypeId == "ProductCategory") query["tip"] = page.id;
        if (currentRoutingTypeId == "ProductDestination") query["bolge"] = page.id;
        if (router.query.slug != searchResultSlug && !page.CustomList && !(currentRoutingTypeId == "ProductSearch" && page.id == 554)) {
            query.slug = [
                searchResultSlug
            ];
            router.replace({
                query: query
            }, undefined, {
                scroll: true
            });
        } else {
            query.slug = [
                page.url
            ];
            router.push({
                query: query
            }, undefined, {
                scroll: true,
                shallow: true
            });
        }
    };
    var setPage = function(p) {
        setParam({
            s: p
        });
    };
    var HandleSubmit = function(e) {
        e.preventDefault();
        router.reload();
    };
    (0,react.useEffect)(function() {
        if (data) criteo/* listing */.rz(SqlDate(router.query.start || ""), SqlDate(router.query.end || ""), router.query.yetiskin || 1 + router.query.cocuk || 0, data.map(function(e) {
            return e.id;
        }));
    }, [
        data
    ]);
    var SqlDate = function(d) {
        var a = d.split("-");
        return a[2] + "." + a[1] + "." + a[0];
    };
    var showBanner = function(index) {
        if (!width) return false;
        if (width > 1280) return index === 8;
        if (width > 640) return index === 3;
        return index === 2;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_Banner, {
                ssr: ssr,
                isAppWebView: isAppWebView
            }),
            ssr.disableHeader != true && /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: HandleSubmit,
                children: ssr.result.ShowTopSearchBar != "0" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_TopSearchBar, {
                    setParam: setParam,
                    RoutingTypeId: ssr.RoutingTypeId,
                    PageId: ssr.result.id
                })
            }),
            ssr.RoutingTypeId == "ShortTerms" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortTerms["default"], {
                hideTitle: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-brand-gray-7 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container ",
                    children: [
                        (ssr.RoutingTypeId == "ShortTerms" && ssr.result.ShortTerms == "1" && data || ssr.RoutingTypeId != "ShortTerms") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_FilterSummary, {
                                    totalRecord: totalRecord,
                                    setParam: setParam
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3",
                                    children: error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: error
                                    }) : isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonView/* default */.Z, {
                                            isPhone: isPhone,
                                            lengthMobile: 6,
                                            length: 9,
                                            flex: false,
                                            width: "ml:w-[406px]",
                                            padding: "px-0"
                                        })
                                    }) : data && data.map(function(item, key) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VillaItem/* default */.Z, {
                                                    index: key,
                                                    data: item,
                                                    shortTerm: ssr.RoutingTypeId == "ShortTerms",
                                                    className: "w-full bg-white"
                                                }),
                                                showBanner(key) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-span-1 sm:col-span-2 xl:col-span-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KiralaGelBanner/* default */.Z, {
                                                        src: width && width > 640 ? "/images/kiralagel-banner/1350x210.jpeg" : "/images/kiralagel-banner/575x260.png",
                                                        listingPage: true,
                                                        heightClass: width && width > 640 ? "h-52" : "h-64",
                                                        deviceType: deviceType
                                                    })
                                                })
                                            ]
                                        }, item.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                    setPage: setPage,
                                    currentPage: currentPage,
                                    totalPage: totalPage
                                })
                            ]
                        }),
                        page.icerik && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_Content, {
                            content: page.icerik
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Pages_ProductCategory = (ProductCategory);


/***/ }),

/***/ 73870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductCategory_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
;// CONCATENATED MODULE: ./components/ProductCategory/PaginationItem.js


var PaginationItem = function(param) {
    var children = param.children, setPage = param.setPage, page = param.page, active = param.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        onClick: setPage ? function() {
            setPage(page);
        } : function() {},
        className: "w-12 h-12 bg-white transition  border-2 rounded  flex items-center justify-center font-semibold text-15 cursor-pointer  hover:border-pagination-colors hover:text-pagination-colors " + (active ? "border-pagination-colors" : "border-[#D1DDE0]"),
        children: children
    });
};
/* harmony default export */ var ProductCategory_PaginationItem = (PaginationItem);

;// CONCATENATED MODULE: ./components/ProductCategory/Pagination.js




var Pagination = function(param) {
    var setPage = param.setPage, currentPage = param.currentPage, totalPage = param.totalPage;
    var Showed = 6;
    var PerSide = Showed / 2;
    var ref = (0,react.useState)([]), pages = ref[0], setPages = ref[1];
    (0,react.useEffect)(function() {
        var start = currentPage == 1 ? 1 : currentPage >= totalPage ? currentPage - PerSide + 1 : currentPage - 1;
        var arr = [];
        if (totalPage <= 3) {
            for(var i = 1; i <= totalPage; i++){
                arr.push(i);
            }
        } else {
            for(var i1 = 0; i1 <= 2; i1++){
                arr.push(start + i1);
            }
        }
        setPages(arr);
    }, [
        currentPage,
        totalPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "flex justify-center gap-x-0.5 ml:gap-x-4 mt-4",
        children: [
            currentPage != 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                setPage: setPage,
                page: currentPage - 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: "PaginationPrev",
                    className: "w-2"
                })
            }),
            currentPage > PerSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                setPage: setPage,
                page: 1,
                children: 1
            }),
            currentPage > PerSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                children: ". . ."
            }),
            pages.map(function(e, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                    setPage: setPage,
                    page: e,
                    active: e == currentPage,
                    children: e
                }, i);
            }),
            currentPage <= totalPage - PerSide + 1 && totalPage > PerSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                children: ". . ."
            }),
            currentPage != totalPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategory_PaginationItem, {
                setPage: setPage,
                page: currentPage + 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: "PaginationNext",
                    className: "w-2"
                })
            })
        ]
    });
};
/* harmony default export */ var ProductCategory_Pagination = (Pagination);


/***/ }),

/***/ 16625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* unused harmony export useDevice */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useWindowSize() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function handleResize() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return {
        width: width
    };
};
function useDevice() {
    var ref = useState({
        isMobile: undefined
    }), r = ref[0], setR = ref[1];
    useEffect(function() {
        var handleResize = // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            if (window.innerWidth < 1024) {
                setR({
                    isMobile: true
                });
            } else {
                setR({
                    isMobile: false
                });
            }
        };
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty array ensures that effect is only run on mount
    return r;
}


/***/ }),

/***/ 17601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


var InfoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 49562).then(__webpack_require__.bind(__webpack_require__, 49562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49562)
            ];
        }
    }
});
var InstagramIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 81147).then(__webpack_require__.bind(__webpack_require__, 81147));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81147)
            ];
        }
    }
});
var LogoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 60563).then(__webpack_require__.bind(__webpack_require__, 60563));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60563)
            ];
        }
    }
});
var FacebookIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55849).then(__webpack_require__.bind(__webpack_require__, 55849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55849)
            ];
        }
    }
});
var YoutubeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 86759).then(__webpack_require__.bind(__webpack_require__, 86759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86759)
            ];
        }
    }
});
var DatepickerArrowsIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 10945).then(__webpack_require__.bind(__webpack_require__, 10945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10945)
            ];
        }
    }
});
var LocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34364).then(__webpack_require__.bind(__webpack_require__, 34364));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34364)
            ];
        }
    }
});
var SearchIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 39750).then(__webpack_require__.bind(__webpack_require__, 39750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39750)
            ];
        }
    }
});
var ArrowDownIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5915).then(__webpack_require__.bind(__webpack_require__, 5915));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5915)
            ];
        }
    }
});
var TimesIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 36539).then(__webpack_require__.bind(__webpack_require__, 36539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36539)
            ];
        }
    }
});
var PaymentOptionIcon1 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 57905).then(__webpack_require__.bind(__webpack_require__, 57905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57905)
            ];
        }
    }
});
var PaymentOptionIcon2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18686).then(__webpack_require__.bind(__webpack_require__, 18686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18686)
            ];
        }
    }
});
var HeartIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14119).then(__webpack_require__.bind(__webpack_require__, 14119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14119)
            ];
        }
    }
});
var AttentionIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55613).then(__webpack_require__.bind(__webpack_require__, 55613));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55613)
            ];
        }
    }
});
var FaturaIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52415).then(__webpack_require__.bind(__webpack_require__, 52415));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52415)
            ];
        }
    }
});
var CallIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 26006).then(__webpack_require__.bind(__webpack_require__, 26006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26006)
            ];
        }
    }
});
var WhatsappnewIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 40305).then(__webpack_require__.bind(__webpack_require__, 40305));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40305)
            ];
        }
    }
});
var ReverseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 72142).then(__webpack_require__.bind(__webpack_require__, 72142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72142)
            ];
        }
    }
});
var MapIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 88450).then(__webpack_require__.bind(__webpack_require__, 88450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88450)
            ];
        }
    }
});
var Icons_new = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 793).then(__webpack_require__.bind(__webpack_require__, 793));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(793)
            ];
        }
    }
});
var Icons_new2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14973).then(__webpack_require__.bind(__webpack_require__, 14973));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14973)
            ];
        }
    }
});
var Icons_new3 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 38796).then(__webpack_require__.bind(__webpack_require__, 38796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38796)
            ];
        }
    }
});
var Icons_new4 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68344).then(__webpack_require__.bind(__webpack_require__, 68344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68344)
            ];
        }
    }
});
var WorkingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 73477).then(__webpack_require__.bind(__webpack_require__, 73477));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73477)
            ];
        }
    }
});
var ProblemreportIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 44059).then(__webpack_require__.bind(__webpack_require__, 44059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44059)
            ];
        }
    }
});
var WheltimeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 63270).then(__webpack_require__.bind(__webpack_require__, 63270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63270)
            ];
        }
    }
});
var GancelIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 51623).then(__webpack_require__.bind(__webpack_require__, 51623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51623)
            ];
        }
    }
});
var GuestconfirmationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 21443).then(__webpack_require__.bind(__webpack_require__, 21443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21443)
            ];
        }
    }
});
var CloseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25194).then(__webpack_require__.bind(__webpack_require__, 25194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25194)
            ];
        }
    }
});
var VillaLocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34920).then(__webpack_require__.bind(__webpack_require__, 34920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34920)
            ];
        }
    }
});
var PlayButtonIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17686).then(__webpack_require__.bind(__webpack_require__, 17686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17686)
            ];
        }
    }
});
var DetailIncludedPriceIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 59715).then(__webpack_require__.bind(__webpack_require__, 59715));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59715)
            ];
        }
    }
});
var BarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19272).then(__webpack_require__.bind(__webpack_require__, 19272));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19272)
            ];
        }
    }
});
var CallCenterIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18238).then(__webpack_require__.bind(__webpack_require__, 18238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18238)
            ];
        }
    }
});
var UserIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 78822).then(__webpack_require__.bind(__webpack_require__, 78822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78822)
            ];
        }
    }
});
var ClockIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 76255).then(__webpack_require__.bind(__webpack_require__, 76255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76255)
            ];
        }
    }
});
var PaginationPrevIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17151).then(__webpack_require__.bind(__webpack_require__, 17151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17151)
            ];
        }
    }
});
var PaginationNextIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18229).then(__webpack_require__.bind(__webpack_require__, 18229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18229)
            ];
        }
    }
});
var ShareIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 91788).then(__webpack_require__.bind(__webpack_require__, 91788));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91788)
            ];
        }
    }
});
var HousekeepingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 29097).then(__webpack_require__.bind(__webpack_require__, 29097));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29097)
            ];
        }
    }
});
var CameraIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 22437).then(__webpack_require__.bind(__webpack_require__, 22437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22437)
            ];
        }
    }
});
var TeamIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 42908).then(__webpack_require__.bind(__webpack_require__, 42908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42908)
            ];
        }
    }
});
var CommentIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 97088).then(__webpack_require__.bind(__webpack_require__, 97088));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97088)
            ];
        }
    }
});
var WalletIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18688).then(__webpack_require__.bind(__webpack_require__, 18688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18688)
            ];
        }
    }
});
var UserodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18024).then(__webpack_require__.bind(__webpack_require__, 18024));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18024)
            ];
        }
    }
});
var MailodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 37822).then(__webpack_require__.bind(__webpack_require__, 37822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37822)
            ];
        }
    }
});
var PhoneodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 28892).then(__webpack_require__.bind(__webpack_require__, 28892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28892)
            ];
        }
    }
});
var EditodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 35623).then(__webpack_require__.bind(__webpack_require__, 35623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35623)
            ];
        }
    }
});
var LockodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9748).then(__webpack_require__.bind(__webpack_require__, 9748));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9748)
            ];
        }
    }
});
var LocationPinIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 80707).then(__webpack_require__.bind(__webpack_require__, 80707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80707)
            ];
        }
    }
});
var StarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 99484).then(__webpack_require__.bind(__webpack_require__, 99484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99484)
            ];
        }
    }
});
var KtbIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9842).then(__webpack_require__.bind(__webpack_require__, 9842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9842)
            ];
        }
    }
});
var Icon = function(param) {
    var name = param.name, _size = param.size, size = _size === void 0 ? 24 : _size, className = param.className;
    var icons = {
        info: InfoIcon,
        logo: LogoIcon,
        instagram: InstagramIcon,
        facebook: FacebookIcon,
        youtube: YoutubeIcon,
        datepickerArrows: DatepickerArrowsIcon,
        location: LocationIcon,
        search: SearchIcon,
        ArrowDown: ArrowDownIcon,
        Times: TimesIcon,
        PaymentOption1: PaymentOptionIcon1,
        PaymentOption2: PaymentOptionIcon2,
        Heart: HeartIcon,
        attention: AttentionIcon,
        fatura: FaturaIcon,
        call: CallIcon,
        whatsappnew: WhatsappnewIcon,
        reverse: ReverseIcon,
        map: MapIcon,
        newIcon1: Icons_new,
        newIcon2: Icons_new2,
        newIcon3: Icons_new3,
        newIcon4: Icons_new4,
        working: WorkingIcon,
        villaLocation: VillaLocationIcon,
        PlayButton: PlayButtonIcon,
        DetailIncludedPrice: DetailIncludedPriceIcon,
        Bar: BarIcon,
        CallCenter: CallCenterIcon,
        problemreport: ProblemreportIcon,
        wheltime: WheltimeIcon,
        gancel: GancelIcon,
        guestconfirmation: GuestconfirmationIcon,
        close: CloseIcon,
        user: UserIcon,
        clock: ClockIcon,
        PaginationPrev: PaginationPrevIcon,
        PaginationNext: PaginationNextIcon,
        Share: ShareIcon,
        Wallet: WalletIcon,
        Comment: CommentIcon,
        Camera: CameraIcon,
        Housekeeping: HousekeepingIcon,
        Team: TeamIcon,
        userodeme: UserodemeIcon,
        mailodeme: MailodemeIcon,
        phoneodeme: PhoneodemeIcon,
        editodeme: EditodemeIcon,
        lockodeme: LockodemeIcon,
        LocationPin: LocationPinIcon,
        Star: StarIcon,
        ktb: KtbIcon
    };
    var Component = icons[name];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        size: size,
        className: className
    });
};



/***/ }),

/***/ 62647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getMobilePlatform; }
/* harmony export */ });
var getMobilePlatform = function() {
    if (false) {}
    var ua = navigator.userAgent;
    if (/Android/i.test(ua)) {
        return "android";
    }
    if (/iPhone|iPad|iPod/i.test(ua)) {
        return "ios";
    }
    return "other";
};


/***/ }),

/***/ 63964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ShortTermsBg":"ShortTerms_ShortTermsBg__xQAFU","HideTitle":"ShortTerms_HideTitle__pOfYX"};

/***/ }),

/***/ 7461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TextWhiteShadow":"Banner_TextWhiteShadow__A4x_y"};

/***/ }),

/***/ 79639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ShortTermDay":"TermItem_ShortTermDay__pWB82"};

/***/ })

}]);